import React, { useRef, useState } from "react";
import "./carousel.css";
import Slider from "react-slick";
import { Link } from "react-router-dom";
import { SliderH } from "../../../services/script";

const TradnityCarousel = (props) => {
  const [loadingCarousel, setLoadingCarousel] = useState(true);
  const [sliderHeight, setSliderHeight] = useState(null);

  const { image } = props;
  const counter = useRef(0);

  const imageLoaded = (e) => {
    if (counter.current === 0 && e?.target) {
      setSliderHeight(e.target.offsetHeight);
    }
    counter.current += 1;
    if (counter.current >= 1) {
      setLoadingCarousel(false);
    }
  };

  const hasImages =
    image &&
    image.sliderImages &&
    image.sliderImages.data &&
    image.sliderImages.data.length !== 0;

  return (
    <>
      <section className="mt-2 p-0 small-slider" style={{ position: "relative" }}>

        {/* Skeleton Loader */}
        {loadingCarousel && (
          <div
            className="carousel-skeleton"
            style={{
              width: "80%",
              margin: "0 auto",            // ✅ CENTER
              height: "440px",
              paddingBottom: sliderHeight ? 0 : "22%",
              borderRadius: "12px",
              overflow: "hidden",
              position: "relative",
              marginBottom: "20px",
            }}
          >
            <div className="skeleton-shimmer" />
          </div>
        )}

        {/* Hidden pre-loader to measure real image height */}
        {hasImages && loadingCarousel && (
          <img
            src={image.sliderImages.data[0].image_url}
            alt=""
            aria-hidden="true"
            onLoad={imageLoaded}
            style={{
              position: "absolute",
              opacity: 0,
              pointerEvents: "none",
              width: "100%",
              height: "auto",
              top: 0,
              left: 0,
            }}
          />
        )}

        <Slider
          {...SliderH}
          className="slide-1 home-slider"
          style={loadingCarousel ? { display: "none" } : {}}
        >
          {hasImages ? (
            image.sliderImages.data.map((img, key) => (
              <div key={key}>
                <Link
                  to={
                    img?.slider_product == 1
                      ? "/products"
                      : {
                        pathname: `/products/${img?.category_name
                          ?.toLowerCase()
                          .replace(/\s+/g, "-")}-${img?.slider_product}`,
                        state: {
                          categories: {
                            id: img?.slider_product,
                            image_url: img?.category_image,
                            name: img?.category_name,
                          },
                        },
                      }
                  }
                >
                  <img
                    width="100%"
                    className="carouselImg"
                    src={img.image_url}
                    onLoad={key === 0 ? imageLoaded : undefined}
                    alt="Slider"
                  />
                </Link>
              </div>
            ))
          ) : (
            <div className="skeleton-item skeleton-copy-full-slider" />
          )}
        </Slider>
      </section>
    </>
  );
};

export default TradnityCarousel;